import { EMPTY_FIELD } from 'constants/emptyField';

import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { OrderReportData } from 'types/embedded/orderReport';
import { formatCurrency } from 'utils/formatCurrency';

type CommissionTypes = 'commissionValueByCurrencyOrder' | 'commissionValueByCurrencyCommission';

type Props = Omit<FunctionFieldProps, 'render'> & {
  source: CommissionTypes;
};

export const OrdersReportListCommissionField: React.FC<Props> = ({ label, source }) => {
  return (
    <FunctionField
      label={label}
      render={(record: OrderReportData) => {
        if (!record?.[source]) {
          return EMPTY_FIELD;
        }

        return (
          <>
            <Typography component="span" variant="body2">
              {formatCurrency(Number(record?.[source]?.value))}
            </Typography>{' '}
            <Typography component="span" sx={{ fontWeight: 500 }} variant="body2">
              {record?.[source]?.currency}
            </Typography>
          </>
        );
      }}
    />
  );
};
